module.exports = __webpack_public_path__ + "static/media/carta-compromiso-estudiante.777ed978.pdf";